/* ==========================================================================
   ROYALCHILD — theme behaviour
   Vanilla JS, no dependencies. Cart uses Shopify's Section Rendering API.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- tiny helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  function money(cents) {
    var fmt = (window.RC && window.RC.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withComma = parts.join('.');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0]);
  }

  /* ---------- toast ---------- */
  var toastEl = null, toastTimer = null;
  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'rc-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    requestAnimationFrame(function () { toastEl.classList.add('is-open'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-open'); }, 2600);
  }

  /* ---------- scroll lock ---------- */
  var lockCount = 0;
  function lockScroll(lock) {
    lockCount = Math.max(0, lockCount + (lock ? 1 : -1));
    document.documentElement.style.overflow = lockCount > 0 ? 'hidden' : '';
  }

  /* ======================================================================
     Sticky header
     ====================================================================== */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var sentinelTop = header.offsetTop;
    function update() {
      header.classList.toggle('is-stuck', window.scrollY > sentinelTop + 8);
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () { sentinelTop = header.offsetTop; update(); });
  }

  /* ======================================================================
     Mobile navigation
     ====================================================================== */
  function initMobileNav() {
    var nav = $('[data-mobile-nav]');
    if (!nav) return;
    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      nav.setAttribute('aria-hidden', open ? 'false' : 'true');
      lockScroll(open);
      if (open) { var f = $('a, button', nav); if (f) f.focus(); }
    }
    $$('[data-mobile-nav-open]').forEach(function (b) { on(b, 'click', function () { setOpen(true); }); });
    $$('[data-mobile-nav-close]').forEach(function (b) { on(b, 'click', function () { setOpen(false); }); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) setOpen(false);
    });
  }

  /* ======================================================================
     Cart drawer
     ====================================================================== */
  var Cart = {
    section: 'cart-drawer',

    drawer: function () { return $('[data-cart-drawer]'); },
    overlay: function () { return $('[data-cart-overlay]'); },

    open: function () {
      var d = this.drawer(), o = this.overlay();
      if (!d) return;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      if (o) o.classList.add('is-open');
      lockScroll(true);
      var close = $('[data-cart-close]', d);
      if (close) close.focus();
    },

    close: function () {
      var d = this.drawer(), o = this.overlay();
      if (!d || !d.classList.contains('is-open')) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      if (o) o.classList.remove('is-open');
      lockScroll(false);
    },

    setCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('is-empty', count === 0);
      });
    },

    /* Re-render the drawer markup from the server so money formatting,
       discounts and translations all stay authoritative. */
    refresh: function () {
      var self = this;
      return fetch(ROOT + '?sections=' + self.section, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var host = document.getElementById('shopify-section-' + self.section);
          var markup = data[self.section];
          if (!host || !markup) return;
          var wasOpen = host.querySelector('.rc-drawer.is-open') !== null;
          var parsed = new DOMParser().parseFromString(markup, 'text/html');
          var fresh = parsed.getElementById('shopify-section-' + self.section);
          host.innerHTML = fresh ? fresh.innerHTML : markup;
          if (wasOpen) {
            var d = self.drawer(), o = self.overlay();
            if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); }
            if (o) o.classList.add('is-open');
          }
          var counter = host.querySelector('[data-cart-item-count]');
          if (counter) self.setCount(parseInt(counter.getAttribute('data-cart-item-count'), 10) || 0);
        });
    },

    add: function (formData, submitBtn) {
      var self = this;
      if (submitBtn) { submitBtn.setAttribute('aria-disabled', 'true'); submitBtn.dataset.label = submitBtn.textContent; submitBtn.textContent = 'Adding…'; }
      return fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok) {
            toast(res.body.description || res.body.message || 'Could not add to bag');
            return;
          }
          return self.refresh().then(function () { self.open(); });
        })
        .catch(function () { toast('Something went wrong'); })
        .finally(function () {
          if (submitBtn) {
            submitBtn.removeAttribute('aria-disabled');
            if (submitBtn.dataset.label) submitBtn.textContent = submitBtn.dataset.label;
          }
        });
    },

    change: function (line, quantity) {
      var self = this;
      return fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
          return self.refresh();
        })
        .catch(function () { toast('Something went wrong'); });
    }
  };

  function initCart() {
    /* Add-to-cart forms (product page, quick add) */
    on(document, 'submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form || form.hasAttribute('data-no-ajax')) return;
      e.preventDefault();
      Cart.add(new FormData(form), form.querySelector('[data-add-button]'));
    });

    /* Delegated drawer controls — survives innerHTML swaps */
    on(document, 'click', function (e) {
      var openBtn = e.target.closest('[data-cart-open]');
      if (openBtn) { e.preventDefault(); Cart.open(); return; }

      if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) {
        Cart.close(); return;
      }

      var qtyBtn = e.target.closest('[data-line-change]');
      if (qtyBtn) {
        e.preventDefault();
        Cart.change(parseInt(qtyBtn.getAttribute('data-line'), 10), parseInt(qtyBtn.getAttribute('data-line-change'), 10));
        return;
      }

      var remove = e.target.closest('[data-line-remove]');
      if (remove) {
        e.preventDefault();
        Cart.change(parseInt(remove.getAttribute('data-line-remove'), 10), 0);
      }
    });

    on(document, 'keydown', function (e) { if (e.key === 'Escape') Cart.close(); });
  }

  /* ======================================================================
     Product: variant picker, gallery, quantity, accordions
     ====================================================================== */
  function initProduct(scope) {
    var root = scope || document;

    $$('[data-product-form-wrapper]', root).forEach(function (wrapper) {
      var dataEl = $('[data-product-json]', wrapper);
      if (!dataEl) return;

      var product;
      try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }

      var variantInput = $('[data-variant-id]', wrapper);
      var priceEl = $('[data-price]', wrapper);
      var addBtn = $('[data-add-button]', wrapper);
      var skuEl = $('[data-sku]', wrapper);
      var mainImg = $('[data-gallery-main] img', wrapper.closest('[data-product-root]') || document);

      function selectedOptions() {
        return $$('[data-option-index]', wrapper).map(function (group) {
          var checked = $('input:checked', group);
          return checked ? checked.value : null;
        });
      }

      function findVariant(opts) {
        return product.variants.filter(function (v) {
          return opts.every(function (val, i) { return val === null || v.options[i] === val; });
        })[0];
      }

      function render(variant) {
        if (!variant) {
          if (addBtn) { addBtn.setAttribute('aria-disabled', 'true'); addBtn.textContent = 'Unavailable'; }
          return;
        }
        if (variantInput) variantInput.value = variant.id;

        if (priceEl) {
          var html = '<span>' + money(variant.price) + '</span>';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html += '<span class="rc-price__was">' + money(variant.compare_at_price) + '</span>';
          }
          priceEl.innerHTML = html;
        }

        if (skuEl) skuEl.textContent = variant.sku || '';

        if (addBtn) {
          if (variant.available) {
            addBtn.removeAttribute('aria-disabled');
            addBtn.textContent = addBtn.getAttribute('data-label-add') || 'Add to bag';
          } else {
            addBtn.setAttribute('aria-disabled', 'true');
            addBtn.textContent = addBtn.getAttribute('data-label-sold') || 'Sold out';
          }
        }

        if (variant.featured_image && mainImg) {
          mainImg.src = variant.featured_image.src;
          mainImg.removeAttribute('srcset');
        }

        if (history.replaceState && variant.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
      }

      $$('[data-option-index] input', wrapper).forEach(function (input) {
        on(input, 'change', function () { render(findVariant(selectedOptions())); });
      });

      render(findVariant(selectedOptions()));
    });

    /* Gallery thumbnails */
    $$('[data-product-root]', root).forEach(function (pdp) {
      var main = $('[data-gallery-main] img', pdp);
      $$('[data-gallery-thumb]', pdp).forEach(function (thumb) {
        on(thumb, 'click', function () {
          var full = thumb.getAttribute('data-full');
          if (!full || !main) return;
          main.src = full;
          main.removeAttribute('srcset');
          $$('[data-gallery-thumb]', pdp).forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });

    /* Quantity steppers */
    $$('[data-qty]', root).forEach(function (widget) {
      var input = $('input', widget);
      $$('[data-qty-step]', widget).forEach(function (btn) {
        on(btn, 'click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10);
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    /* Accordions */
    $$('[data-acc-btn]', root).forEach(function (btn) {
      on(btn, 'click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.classList.toggle('is-open', !expanded);
      });
    });
  }

  /* ======================================================================
     Wishlist (localStorage — no account required)
     ====================================================================== */
  var WISH_KEY = 'rc:wishlist';
  function readWish() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch (e) { return []; }
  }
  function writeWish(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
  }
  function initWishlist() {
    function paint() {
      var list = readWish();
      $$('[data-wish]').forEach(function (btn) {
        var active = list.indexOf(btn.getAttribute('data-wish')) !== -1;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      $$('[data-wish-count]').forEach(function (el) { el.textContent = list.length; });
    }
    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-wish]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-wish');
      var list = readWish();
      var i = list.indexOf(id);
      if (i === -1) { list.push(id); toast('Saved to wishlist'); } else { list.splice(i, 1); }
      writeWish(list);
      paint();
    });
    paint();
  }

  /* ======================================================================
     Reveal on scroll
     ====================================================================== */
  function initReveal() {
    var items = $$('.rc-reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ======================================================================
     Collection sort
     ====================================================================== */
  function initSort() {
    $$('[data-sort]').forEach(function (select) {
      on(select, 'change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ======================================================================
     Boot
     ====================================================================== */
  function boot() {
    initHeader();
    initMobileNav();
    initCart();
    initProduct();
    initWishlist();
    initReveal();
    initSort();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-init inside the theme editor when a section is redrawn */
  document.addEventListener('shopify:section:load', function (e) {
    initProduct(e.target);
    initReveal();
    initHeader();
    initMobileNav();
  });

  window.RCTheme = { cart: Cart, toast: toast };
})();
